
import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import Head from '../../components/navbar/Head.js';
import NavBar from '../../components/navbar/NavBar.js';
import Card from 'react-bootstrap/Card';
import '../../api/index.js';
import '../../helper/ApiHelper.js'
import '../../api/index.js';
import '../../helper/ApiHelper.js'
import Button from 'react-bootstrap/Button';
import { isNumeric, isLength } from 'validator';

import { insertCategoriesDetails } from '../../api/index.js'

import { useNavigate } from 'react-router-dom';
import { hideLoading, showLoading } from '../../helper/Helper.js';

const AddCategories = () => {

    const [validated, setValidated] = useState(false);
    const [checkDisplayOrder, setCheckDisplayOrder] = useState('');
    const [formData, setFormData] = useState('');
    const [status, setStatus] = useState('publish');
    const navigate = useNavigate();

    const handleCancel = () => {
        navigate('/Categories', {replace: true});
    };

    const handleChangeStatus = (event) => {
        setStatus(event.target.value);
    }

    const handleChange = (event) => {
        const { name, value } = event.target || '';
        setFormData((prevData) => ({ ...prevData, [name]: value }));


        if (name === 'displayOrder') {
            if (!isNumeric(value)) {
                setCheckDisplayOrder('Please enter numbers only.');
            } else {
                setCheckDisplayOrder('');
            }
        }


    }


    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        const categoryNameEng = formData.categoryNameEng || null;
        const categoryNameThai = formData.categoryNameThai || null;
        const displayOrder = formData.displayOrder || null;

        if (form.checkValidity() === true) {
            event.preventDefault();
            event.stopPropagation();
            // console.log(formData);

            showLoading();
            insertCategoriesDetails(categoryNameEng, categoryNameThai, status, displayOrder).then(handleCategoriesDetailsResponse);
        }

        setValidated(true);
    }

    const handleCategoriesDetailsResponse = async (response) => {
        hideLoading();
        navigate('/Categories', { replace: true });
    };

    const handleBackClick = () => {
        navigate('/Categories', { replace: true });
    };


    return (
        <div >
            <Head />
            <Row className='row-navbar'>
                <NavBar />
                <Col className='row-context' >
                    <main>

                        <div className='box-context'>
                            <Row>
                                <div className='col-md-12' >
                                    <Row>
                                        <div className='col-md-6'>
                                            <span className='title-text'> <div className='title-content-text' onClick={() => handleBackClick()}>Categories</div><div style={{marginLeft: '10px',marginRight: '10px'}}>{'›'}</div> Add Categories  </span>
                                            <p className='context-text'>Manage categories</p>
                                        </div>
                                        <div className='col-md-6 col-6-div' style={{ textAlign: 'right' }}>
                                            <Row>
                                                <Col sm={5} >
                                                </Col>
                                            </Row>
                                        </div>
                                    </Row>
                                </div>
                            </Row>
                            <br></br>

                            <div className='box-table'>
                                <Card className='card-box'>
                                    <Card.Body>


                                        <Col className='' >
                                            <main>
                                                <div className=''>
                                                    <div className=''>
                                                        <div className='content-box-inner'>
                                                            <Form noValidate validated={validated} onSubmit={handleSubmit}>

                                                                <Form.Group as={Row} className="mb-3" controlId="">
                                                                    <Form.Label column sm="4">
                                                                        Category Name - English
                                                                    </Form.Label>
                                                                    <Col sm="5">
                                                                        <Form.Control required type="text" maxLength={60} value={formData.categoryNameEng} name="categoryNameEng" onChange={handleChange} />
                                                                    </Col>
                                                                </Form.Group>

                                                                <Form.Group as={Row} className="mb-3" controlId="">
                                                                    <Form.Label column sm="4">
                                                                        Category Name - Thai
                                                                    </Form.Label>
                                                                    <Col sm="5">
                                                                        <Form.Control required type="text" maxLength={60} value={formData.categoryNameThai} name="categoryNameThai" onChange={handleChange} />
                                                                    </Col>
                                                                </Form.Group>


                                                                <Form.Group as={Row} className="mb-3" controlId="">
                                                                    <Form.Label column sm="4">
                                                                        Status
                                                                    </Form.Label>
                                                                    <Col sm="5">
                                                                        <Form.Select required value={status} name="status" onChange={handleChangeStatus}>
                                                                            <option value='publish' >Publish</option>
                                                                            <option value='draft' >Draft</option>
                                                                        </Form.Select>
                                                                    </Col>
                                                                </Form.Group>

                                                                <Form.Group as={Row} className="mb-3" controlId="">
                                                                    <Form.Label column sm="4">
                                                                        Display Order
                                                                    </Form.Label>
                                                                    <Col sm="5">
                                                                        <Form.Control required type="text" isInvalid={!!checkDisplayOrder} value={formData.displayOrder} name="displayOrder" onChange={handleChange} />
                                                                        <Form.Control.Feedback type="invalid">
                                                                            {checkDisplayOrder}
                                                                        </Form.Control.Feedback>
                                                                    </Col>
                                                                </Form.Group>
                                                                <br />

                                                                <center>
                                                                <Button className='button-form-cancel button-main button-white' onClick={handleCancel} variant="primary">Cancel</Button>
                                                                    <Button className='button-form-save button-main button-orange' type="submit">Save</Button>
                                                                </center>

                                                            </Form>
                                                        </div>
                                                    </div>
                                                </div>

                                            </main>
                                        </Col>

                                    </Card.Body>
                                </Card>
                            </div>
                        </div>

                    </main>
                </Col>


            </Row>
        </div >
    );
};

export default AddCategories;
